import { attach, createEvent, createStore } from 'effector';
import { createInitialEntityState, EntityState, User } from '@nx-frontend/shared/types';

export type UsersState = EntityState<User>;
export const setUserStateEvent = createEvent<UsersState>();
export const setUsersEvent = createEvent<User[]>();
export const upsertUsersEvent = createEvent<User[]>();
export const $usersState = createStore<UsersState>(createInitialEntityState())
  .on(setUserStateEvent, (_, state) => {
    return { ...state };
  })
  .on(setUsersEvent, (state, users) => {
    const entities: Record<string, User> = {};
    users.forEach((user) => {
      entities[user.id] = user;
    });
    return { entities, ids: Object.keys(entities) };
  })
  .on(upsertUsersEvent, (state, users) => {
    const entities = { ...state.entities };
    users.forEach((user) => {
      entities[user.id] = user;
    });
    return { ...state, entities, ids: Object.keys(entities) };
  });

export const $userEmails = $usersState.map((state) => Object.values(state.entities).map((user) => user.email));

export function usersToState(users: User[]): UsersState {
  const entities: Record<string, User> = {};
  users.forEach((user) => {
    entities[user.id] = user;
  });
  return { entities, ids: Object.keys(entities) };
}

export const getUserByIdFx = attach({
  source: [$usersState],
  effect: ([userState]: [UsersState], { id }: { id: number }) => {
    const entities = userState.entities;
    return entities[id] ?? null;
  },
});

export function getUserByIdParams(id: number) {
  return {
    keys: [id],
    store: $usersState,
    fn: (state: UsersState, [keyId]: number[]) => state.entities[keyId] ?? null,
  };
}
